export default __webpack_public_path__ + "static/media/logo_team.2d823f42.png";